<!-- 增改单位组 -->
<template>
  <div>
    <el-dialog
      width="420px"
      :title="index === '' ? '新增单位' : '编辑单位'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form ref="refForm" :column="formColumn" :data.sync="selfData" :rules="rules" />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    index: {
      type: [Number, String],
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      formColumn: [
        {
          type: 'text',
          field: 'dan_wei_zu_name',
          title: '单位分组',
          placeholder: '如：重量/长度/包装/体积等',
          width: '100%',
          required: true
        }
      ],
      rules: {
        dan_wei_zu_name: [{ required: true, message: '请输入单位分组' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.initSelfData()
  },
  methods: {
    // 初始化数据
    initSelfData() {
      let result = {}
      if (this.index === '') {
        result = {
          dan_wei_zu_name: '',
          gong_shi_list: [],
          dan_wei_list: [
            {
              dan_wei_name: '',
              zhuan_huan_zhi: '1',
              is_zhu_ji_liang: true,
              is_mo_ren_dan_wei: false,
              verify_unit_val: ''
            }
          ]
        }
      } else {
        result = this.$util.deepCopy(this.data.dan_wei_zu_list[this.index])
      }
      this.selfData = result
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          // 校验名称不能重复
          let list = this.$util.deepCopy(this.data.dan_wei_zu_list)
          if (this.index !== '') {
            let result = this.data.dan_wei_zu_list.filter((item, index) => {
              return index !== this.index
            })
            list = this.$util.deepCopy(result)
          }
          let isPass = list.every((item) => {
            return item.dan_wei_zu_name !== this.selfData.dan_wei_zu_name
          })
          if (!isPass) {
            this.$message.error('单位分组不能重复')
            return
          }

          // 处理时间
          if (this.selfData.dan_wei_zu_name === '时间') {
            this.$message.error('单位分组不能命名为时间')
            return
          }

          // 处理公共单位
          if (this.selfData.dan_wei_zu_name === '公共单位') {
            this.selfData.gong_shi_list = ['1']
          }

          this.$emit('success', this.selfData)
          this.popupCancel()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
